import { gql } from '@apollo/client';

export const GET_SECURITY_CLASS_REPORTS = gql`
  query SecurityClassReports($skip: Int = 0, $take: Int = 1000) {
    securityClassReportReports(skip: $skip, take: $take) {
      source
      shortDesc
      longDesc
      sortOrder
      rptSecClass
    }
  }
`;
